import React, { useRef } from 'react';
import { RailProps } from './types';
import RailContext from '../RailContext';
import Desktop from './components/Desktop';
import Mobile from './components/Mobile';

const Rail = (props: RailProps) => {
  const {
    children,
    appliedFacetsCount,
    newDashboard = false,
    hasLeftFacetedGrid = false,
    hasMarketingDataEBB = false,
    isModelToggleEnabled = false,
    ...context
  } = props;

  const scrollableRef = useRef<HTMLElement>(null);

  return (
    <RailContext.Provider
      value={{
        ...context,
        scrollableRef: scrollableRef.current,
      }}
    >
      {hasLeftFacetedGrid ? (
        <Desktop>{children}</Desktop>
      ) : (
        <Mobile
          appliedFacetsCount={appliedFacetsCount}
          hasMarketingDataEBB={hasMarketingDataEBB}
          isModelToggleEnabled={isModelToggleEnabled}
          newDashboard={newDashboard}
        >
          {children}
        </Mobile>
      )}
    </RailContext.Provider>
  );
};
Rail.defaultProps = {
  hasLeftFacetedGrid: false,
  newDashboard: false,
  isModelToggleEnabled: false,
  onFacetChange: () => {},
};

export default Rail;
